<!-- `<strong>` around snapshotTime: the value changes as the RPO slider moves,
so the user's eye needs to land on it quickly. -->
@if (realTime) {
  <div class="recovery-time-notice">
    <svg lucideInfo></svg>
    <p>
      Resources that are real-time replicated to the recovery environment will be restored with current data. Other
      resources will be restored as of <strong>{{ snapshotTime }}</strong
      >.
    </p>
  </div>
} @else {
  <div class="recovery-time-notice">
    <svg lucideInfo></svg>
    <p>
      Resources will be replicated to the recovery environment with data and infrastructure restored from backups that
      were captured at <strong>{{ snapshotTime }}</strong
      >.
    </p>
  </div>
}
